export function hexToRgba(hex: string, alpha: number): string {
    const m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);

    return `rgba(${parseInt(m![1], 16)}, ${parseInt(m![2], 16)}, ${parseInt(m![3], 16)}, ${alpha})`;
}
